import React, {useState} from "react";
import {Button, Descriptions, Form, Input, message, Modal, Select, Checkbox} from "antd";
import slugify from "slugify";
import BusinessRepo from "../../../repository/business";

const BusinessNew = Form.create({name: 'new_business'})(props => {
  const { form, visible } = props;
  const [loading, setLoading] = useState(false);
  const [slug, setSlug] = useState("");

  const save = () => {
    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        BusinessRepo.create(values).then(
          result => {
            message.success('Business was created');
            close();
          },
          error => {
            console.error(error.response);
            message.error('Error creating business');
            setLoading(false);
          },
        );
      }
    });
  };

  const close = () => {
    form.resetFields();
    setLoading(false);
    props.close();
  };

  return (
    <Modal
      visible={visible || false}
      confirmLoading={loading}
      title="Create a new business"
      onOk={save}
      onCancel={close}
      footer={[
        <Button key="back" onClick={close}>Cancel</Button>,
        <Button key="submit" type="primary" loading={loading} onClick={save}>Create</Button>,
      ]}
    >
      <Descriptions bordered>
        <Descriptions.Item label="Country" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator('country', {
              rules: [
                {
                  required: true,
                  message: 'Country is required'
                },
              ],
            })(
              <Select style={{"width": "100%"}}>
                <Select.Option value="mx">Mexico</Select.Option>
                <Select.Option value="cl">Chile</Select.Option>
                <Select.Option value="es">Spain</Select.Option>
                <Select.Option value="br">Brazil</Select.Option>
                <Select.Option value="pe">Peru</Select.Option>
              </Select>
            )}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Name" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: 'Name is required',
                },
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Alias" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator('alias', {
              rules: [
                {
                  required: true,
                  message: 'Alias is required',
                },
              ],
            })(<Input style={{"width": "100%"}} onChange={e => setSlug(slugify(e.target.value, {remove: /[*+~.()'"!:@]/g, lower: true}))} />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Slug" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator('slug', {
              initialValue: slug,
            })(<Input disabled />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Tax ID" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator('tax_id', {
              rules: [
                {
                  required: true,
                  message: 'Tax ID is required',
                },
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Allow Direct Debits" span={3}>
            <Form.Item style={{padding: 0, margin: 0}}>
              {form.getFieldDecorator('direct_debit')(<Checkbox />)}
            </Form.Item>
          </Descriptions.Item>
        <Descriptions.Item label="Contact email" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator('email', {
              rules: [
                {
                  required: true,
                  message: 'Contact email is required',
                },
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Contact phone" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator('phone', {
              rules: [
                {
                  required: true,
                  message: 'Contact phone is required',
                },
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
});

export default BusinessNew;